"use strict";

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __await = this && this.__await || function (v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
};

var __asyncGenerator = this && this.__asyncGenerator || function (thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
      i,
      q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;

  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }

  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }

  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }

  function fulfill(value) {
    resume("next", value);
  }

  function reject(value) {
    resume("throw", value);
  }

  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
};

var __asyncValues = this && this.__asyncValues || function (o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
};

var __asyncDelegator = this && this.__asyncDelegator || function (o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) {
    throw e;
  }), verb("return"), i[Symbol.iterator] = function () {
    return this;
  }, i;

  function verb(n, f) {
    i[n] = o[n] ? function (v) {
      return (p = !p) ? {
        value: __await(o[n](v)),
        done: n === "return"
      } : f ? f(v) : v;
    } : f;
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normaliseInput = void 0;
/* eslint-disable @typescript-eslint/no-use-before-define */

var buffer_1 = require("buffer");
/**
 * Transform types
 *
 * @remarks
 * This function comes from {@link https://github.com/ipfs/js-ipfs-utils/blob/master/src/files/normalise-input.js}
 * @example
 * Supported types
 * ```yaml
 * // INPUT TYPES
 * Bytes (Buffer|ArrayBuffer|TypedArray) [single file]
 * Bloby (Blob|File) [single file]
 * String [single file]
 * { path, content: Bytes } [single file]
 * { path, content: Bloby } [single file]
 * { path, content: String } [single file]
 * { path, content: Iterable<Number> } [single file]
 * { path, content: Iterable<Bytes> } [single file]
 * { path, content: AsyncIterable<Bytes> } [single file]
 * Iterable<Number> [single file]
 * Iterable<Bytes> [single file]
 * Iterable<Bloby> [multiple files]
 * Iterable<String> [multiple files]
 * Iterable<{ path, content: Bytes }> [multiple files]
 * Iterable<{ path, content: Bloby }> [multiple files]
 * Iterable<{ path, content: String }> [multiple files]
 * Iterable<{ path, content: Iterable<Number> }> [multiple files]
 * Iterable<{ path, content: Iterable<Bytes> }> [multiple files]
 * Iterable<{ path, content: AsyncIterable<Bytes> }> [multiple files]
 * AsyncIterable<Bytes> [single file]
 * AsyncIterable<Bloby> [multiple files]
 * AsyncIterable<String> [multiple files]
 * AsyncIterable<{ path, content: Bytes }> [multiple files]
 * AsyncIterable<{ path, content: Bloby }> [multiple files]
 * AsyncIterable<{ path, content: String }> [multiple files]
 * AsyncIterable<{ path, content: Iterable<Number> }> [multiple files]
 * AsyncIterable<{ path, content: Iterable<Bytes> }> [multiple files]
 * AsyncIterable<{ path, content: AsyncIterable<Bytes> }> [multiple files]
 *
 * // OUTPUT
 * AsyncIterable<{ path, content: AsyncIterable<Buffer> }>
 * ```
 *
 * @public
 *
 * @param {Object} input
 * @return AsyncInterable<{ path, content: AsyncIterable<Buffer> }>
 */


function normaliseInput(input) {
  // must give us something
  if (input === null || input === undefined) {
    throw new Error("Unexpected input: ".concat(input));
  } // String


  if (typeof input === 'string' || input instanceof String) {
    return function () {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __await(toFileObject(input));

              case 2:
                _context.next = 4;
                return _context.sent;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }();
  } // Buffer|ArrayBuffer|TypedArray
  // Blob|File


  if (isBytes(input) || isBloby(input)) {
    return function () {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __await(toFileObject(input));

              case 2:
                _context2.next = 4;
                return _context2.sent;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }();
  } // Iterable<?>


  if (input[Symbol.iterator]) {
    return function () {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var iterator, first, _iterator, _step, obj;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // eslint-disable-line require-await
                iterator = input[Symbol.iterator]();
                first = iterator.next();

                if (!first.done) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 5;
                return __await(iterator // Iterable<Number>
                // Iterable<Bytes>
                );

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
                if (!(Number.isInteger(first.value) || isBytes(first.value))) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 9;
                return __await(toFileObject( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return first.value;

                        case 2:
                          return _context3.delegateYield(iterator, "t0", 3);

                        case 3:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })()));

              case 9:
                _context4.next = 11;
                return _context4.sent;

              case 11:
                _context4.next = 13;
                return __await(void 0);

              case 13:
                return _context4.abrupt("return", _context4.sent);

              case 14:
                if (!(isFileObject(first.value) || isBloby(first.value) || typeof first.value === 'string')) {
                  _context4.next = 41;
                  break;
                }

                _context4.next = 17;
                return __await(toFileObject(first.value));

              case 17:
                _context4.next = 19;
                return _context4.sent;

              case 19:
                _iterator = _createForOfIteratorHelper(iterator);
                _context4.prev = 20;

                _iterator.s();

              case 22:
                if ((_step = _iterator.n()).done) {
                  _context4.next = 30;
                  break;
                }

                obj = _step.value;
                _context4.next = 26;
                return __await(toFileObject(obj));

              case 26:
                _context4.next = 28;
                return _context4.sent;

              case 28:
                _context4.next = 22;
                break;

              case 30:
                _context4.next = 35;
                break;

              case 32:
                _context4.prev = 32;
                _context4.t0 = _context4["catch"](20);

                _iterator.e(_context4.t0);

              case 35:
                _context4.prev = 35;

                _iterator.f();

                return _context4.finish(35);

              case 38:
                _context4.next = 40;
                return __await(void 0);

              case 40:
                return _context4.abrupt("return", _context4.sent);

              case 41:
                throw new Error('Unexpected input: ' + typeof input);

              case 42:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[20, 32, 35, 38]]);
      }));
    }();
  } // window.ReadableStream


  if (typeof input.getReader === 'function') {
    return function () {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var e_1, _a, _b, _c, obj;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _b = __asyncValues(browserStreamToIt(input));

              case 2:
                _context5.next = 4;
                return __await(_b.next());

              case 4:
                _c = _context5.sent;

                if (_c.done) {
                  _context5.next = 13;
                  break;
                }

                obj = _c.value;
                _context5.next = 9;
                return __await(toFileObject(obj));

              case 9:
                _context5.next = 11;
                return _context5.sent;

              case 11:
                _context5.next = 2;
                break;

              case 13:
                _context5.next = 18;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](0);
                e_1 = {
                  error: _context5.t0
                };

              case 18:
                _context5.prev = 18;
                _context5.prev = 19;

                if (!(_c && !_c.done && (_a = _b.return))) {
                  _context5.next = 23;
                  break;
                }

                _context5.next = 23;
                return __await(_a.call(_b));

              case 23:
                _context5.prev = 23;

                if (!e_1) {
                  _context5.next = 26;
                  break;
                }

                throw e_1.error;

              case 26:
                return _context5.finish(23);

              case 27:
                return _context5.finish(18);

              case 28:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 15, 18, 28], [19,, 23, 27]]);
      }));
    }();
  } // AsyncIterable<?>


  if (input[Symbol.asyncIterator]) {
    return function () {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var e_2, _a, iterator, first, iterator_1, iterator_1_1, obj;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                iterator = input[Symbol.asyncIterator]();
                _context7.next = 3;
                return __await(iterator.next());

              case 3:
                first = _context7.sent;

                if (!first.done) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 7;
                return __await(iterator // AsyncIterable<Bytes>
                );

              case 7:
                return _context7.abrupt("return", _context7.sent);

              case 8:
                if (!isBytes(first.value)) {
                  _context7.next = 16;
                  break;
                }

                _context7.next = 11;
                return __await(toFileObject(function () {
                  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return __await(first.value);

                          case 2:
                            _context6.next = 4;
                            return _context6.sent;

                          case 4:
                            _context6.t0 = __await;
                            return _context6.delegateYield(__asyncDelegator(__asyncValues(iterator)), "t1", 6);

                          case 6:
                            _context6.t2 = _context6.t1;
                            _context6.next = 9;
                            return (0, _context6.t0)(_context6.t2);

                          case 9:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));
                }()));

              case 11:
                _context7.next = 13;
                return _context7.sent;

              case 13:
                _context7.next = 15;
                return __await(void 0);

              case 15:
                return _context7.abrupt("return", _context7.sent);

              case 16:
                if (!(isFileObject(first.value) || isBloby(first.value) || typeof first.value === 'string')) {
                  _context7.next = 52;
                  break;
                }

                _context7.next = 19;
                return __await(toFileObject(first.value));

              case 19:
                _context7.next = 21;
                return _context7.sent;

              case 21:
                _context7.prev = 21;
                iterator_1 = __asyncValues(iterator);

              case 23:
                _context7.next = 25;
                return __await(iterator_1.next());

              case 25:
                iterator_1_1 = _context7.sent;

                if (iterator_1_1.done) {
                  _context7.next = 34;
                  break;
                }

                obj = iterator_1_1.value;
                _context7.next = 30;
                return __await(toFileObject(obj));

              case 30:
                _context7.next = 32;
                return _context7.sent;

              case 32:
                _context7.next = 23;
                break;

              case 34:
                _context7.next = 39;
                break;

              case 36:
                _context7.prev = 36;
                _context7.t0 = _context7["catch"](21);
                e_2 = {
                  error: _context7.t0
                };

              case 39:
                _context7.prev = 39;
                _context7.prev = 40;

                if (!(iterator_1_1 && !iterator_1_1.done && (_a = iterator_1.return))) {
                  _context7.next = 44;
                  break;
                }

                _context7.next = 44;
                return __await(_a.call(iterator_1));

              case 44:
                _context7.prev = 44;

                if (!e_2) {
                  _context7.next = 47;
                  break;
                }

                throw e_2.error;

              case 47:
                return _context7.finish(44);

              case 48:
                return _context7.finish(39);

              case 49:
                _context7.next = 51;
                return __await(void 0);

              case 51:
                return _context7.abrupt("return", _context7.sent);

              case 52:
                throw new Error('Unexpected input: ' + typeof input);

              case 53:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[21, 36, 39, 49], [40,, 44, 48]]);
      }));
    }();
  } // { path, content: ? }
  // Note: Detected _after_ AsyncIterable<?> because Node.js streams have a
  // `path` property that passes this check.


  if (isFileObject(input)) {
    return function () {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return __await(toFileObject(input));

              case 2:
                _context8.next = 4;
                return _context8.sent;

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }();
  }

  throw new Error('Unexpected input: ' + typeof input);
}

exports.normaliseInput = normaliseInput;

function toFileObject(input) {
  var obj = {
    path: input.path || '',
    mode: input.mode,
    mtime: input.mtime
  };

  if (input.content) {
    obj.content = toAsyncIterable(input.content);
  } else if (!input.path) {
    // Not already a file object with path or content prop
    obj.content = toAsyncIterable(input);
  }

  return obj;
}

function toAsyncIterable(input) {
  // Bytes | String
  if (isBytes(input) || typeof input === 'string') {
    return function () {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __await(toBuffer(input));

              case 2:
                _context9.next = 4;
                return _context9.sent;

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
    }();
  } // Bloby


  if (isBloby(input)) {
    return blobToAsyncGenerator(input);
  } // Browser stream


  if (typeof input.getReader === 'function') {
    return browserStreamToIt(input);
  } // Iterator<?>


  if (input[Symbol.iterator]) {
    return function () {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var iterator, first, _iterator2, _step2, chunk;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                // eslint-disable-line require-await
                iterator = input[Symbol.iterator]();
                first = iterator.next();

                if (!first.done) {
                  _context11.next = 6;
                  break;
                }

                _context11.next = 5;
                return __await(iterator // Iterable<Number>
                );

              case 5:
                return _context11.abrupt("return", _context11.sent);

              case 6:
                if (!Number.isInteger(first.value)) {
                  _context11.next = 14;
                  break;
                }

                _context11.next = 9;
                return __await(toBuffer(Array.from( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                  return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          _context10.next = 2;
                          return first.value;

                        case 2:
                          return _context10.delegateYield(iterator, "t0", 3);

                        case 3:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10);
                })())));

              case 9:
                _context11.next = 11;
                return _context11.sent;

              case 11:
                _context11.next = 13;
                return __await(void 0);

              case 13:
                return _context11.abrupt("return", _context11.sent);

              case 14:
                if (!isBytes(first.value)) {
                  _context11.next = 41;
                  break;
                }

                _context11.next = 17;
                return __await(toBuffer(first.value));

              case 17:
                _context11.next = 19;
                return _context11.sent;

              case 19:
                _iterator2 = _createForOfIteratorHelper(iterator);
                _context11.prev = 20;

                _iterator2.s();

              case 22:
                if ((_step2 = _iterator2.n()).done) {
                  _context11.next = 30;
                  break;
                }

                chunk = _step2.value;
                _context11.next = 26;
                return __await(toBuffer(chunk));

              case 26:
                _context11.next = 28;
                return _context11.sent;

              case 28:
                _context11.next = 22;
                break;

              case 30:
                _context11.next = 35;
                break;

              case 32:
                _context11.prev = 32;
                _context11.t0 = _context11["catch"](20);

                _iterator2.e(_context11.t0);

              case 35:
                _context11.prev = 35;

                _iterator2.f();

                return _context11.finish(35);

              case 38:
                _context11.next = 40;
                return __await(void 0);

              case 40:
                return _context11.abrupt("return", _context11.sent);

              case 41:
                throw new Error('Unexpected input: ' + typeof input);

              case 42:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[20, 32, 35, 38]]);
      }));
    }();
  } // AsyncIterable<Bytes>


  if (input[Symbol.asyncIterator]) {
    return function () {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var e_3, _a, input_1, input_1_1, chunk;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                input_1 = __asyncValues(input);

              case 2:
                _context12.next = 4;
                return __await(input_1.next());

              case 4:
                input_1_1 = _context12.sent;

                if (input_1_1.done) {
                  _context12.next = 13;
                  break;
                }

                chunk = input_1_1.value;
                _context12.next = 9;
                return __await(toBuffer(chunk));

              case 9:
                _context12.next = 11;
                return _context12.sent;

              case 11:
                _context12.next = 2;
                break;

              case 13:
                _context12.next = 18;
                break;

              case 15:
                _context12.prev = 15;
                _context12.t0 = _context12["catch"](0);
                e_3 = {
                  error: _context12.t0
                };

              case 18:
                _context12.prev = 18;
                _context12.prev = 19;

                if (!(input_1_1 && !input_1_1.done && (_a = input_1.return))) {
                  _context12.next = 23;
                  break;
                }

                _context12.next = 23;
                return __await(_a.call(input_1));

              case 23:
                _context12.prev = 23;

                if (!e_3) {
                  _context12.next = 26;
                  break;
                }

                throw e_3.error;

              case 26:
                return _context12.finish(23);

              case 27:
                return _context12.finish(18);

              case 28:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[0, 15, 18, 28], [19,, 23, 27]]);
      }));
    }();
  }

  throw new Error("Unexpected input: ".concat(input));
}

function toBuffer(chunk) {
  return isBytes(chunk) ? chunk : buffer_1.Buffer.from(chunk);
}

function isBytes(obj) {
  return buffer_1.Buffer.isBuffer(obj) || ArrayBuffer.isView(obj) || obj instanceof ArrayBuffer;
}

function isBloby(obj) {
  return typeof globalThis.Blob !== 'undefined' && obj instanceof globalThis.Blob;
} // An object with a path or content property


function isFileObject(obj) {
  return typeof obj === 'object' && (obj.path || obj.content);
}

function blobToAsyncGenerator(blob) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  if (typeof blob.stream === 'function') {
    // firefox < 69 does not support blob.stream()
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return browserStreamToIt(blob.stream());
  }

  return readBlob(blob);
}

function browserStreamToIt(stream) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function browserStreamToIt_1() {
    var reader, result;
    return _regeneratorRuntime.wrap(function browserStreamToIt_1$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            reader = stream.getReader();

          case 1:
            if (!true) {
              _context13.next = 15;
              break;
            }

            _context13.next = 4;
            return __await(reader.read());

          case 4:
            result = _context13.sent;

            if (!result.done) {
              _context13.next = 9;
              break;
            }

            _context13.next = 8;
            return __await(void 0);

          case 8:
            return _context13.abrupt("return", _context13.sent);

          case 9:
            _context13.next = 11;
            return __await(result.value);

          case 11:
            _context13.next = 13;
            return _context13.sent;

          case 13:
            _context13.next = 1;
            break;

          case 15:
          case "end":
            return _context13.stop();
        }
      }
    }, browserStreamToIt_1);
  }));
}

function readBlob(blob, options) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function readBlob_1() {
    var reader, chunkSize, offset, getNextChunk, data;
    return _regeneratorRuntime.wrap(function readBlob_1$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            options = options || {};
            reader = new globalThis.FileReader();
            chunkSize = options.chunkSize || 1024 * 1024;
            offset = options.offset || 0;

            getNextChunk = function getNextChunk() {
              return new Promise(function (resolve, reject) {
                reader.onloadend = function (e) {
                  var _a;

                  var data = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
                  resolve(data.byteLength === 0 ? null : data);
                };

                reader.onerror = reject;
                var end = offset + chunkSize;
                var slice = blob.slice(offset, end);
                reader.readAsArrayBuffer(slice);
                offset = end;
              });
            };

          case 5:
            if (!true) {
              _context14.next = 19;
              break;
            }

            _context14.next = 8;
            return __await(getNextChunk());

          case 8:
            data = _context14.sent;

            if (!(data == null)) {
              _context14.next = 13;
              break;
            }

            _context14.next = 12;
            return __await(void 0);

          case 12:
            return _context14.abrupt("return", _context14.sent);

          case 13:
            _context14.next = 15;
            return __await(buffer_1.Buffer.from(data));

          case 15:
            _context14.next = 17;
            return _context14.sent;

          case 17:
            _context14.next = 5;
            break;

          case 19:
          case "end":
            return _context14.stop();
        }
      }
    }, readBlob_1);
  }));
}